import { RouteConfig } from 'vue-router';

import regionOverview from './modules/region-overview';

const RegionOverviewRoutesConfig: Array<RouteConfig> = [regionOverview];

export default RegionOverviewRoutesConfig;
